<template>
    <div class="box shadow" v-loading="loading" v-if="achievements.length > 0">
        <template>
            <div
                v-for="(achievement, indexGr) in achievements"
                :key="indexGr"
                class="report"
            >
                <div class="report-header">
                    <div class="report-header-left">
                        <h3>{{ achievement.name }}</h3>
                    </div>
                    <div class="report-header-right">
                        <a
                            :href="`https://reporting.${rsvDomain}/api/v1/report/zip?groups=${achievement.id}&jwt=${userJwt}`"
                            >{{
                                isMobile ? 'Скачать' : 'Скачать все достижения'
                            }}</a
                        >
                    </div>
                </div>
                <ReportingItem
                    v-for="(item, index) in achievement.reports"
                    :key="index"
                    :item="item"
                    :isAchievement="true"
                />
            </div>
        </template>
    </div>
    <EmptyTabsCard
        v-else
        :loading="loading"
        :emptyImgLink="emptyImgLink"
        cardTitle="Достижения"
        toFullRouter="/proposal/create"
        emptyText="У вас пока нет достижений"
        no-action
    />
</template>

<script>
import EmptyTabsCard from '@/components/UI/EmptyTabsCard.vue';

const getters = ['achievements', 'isMobile'];
const actions = ['loadAchievements'];

import ReportingItem from './components/ReportingItem';
import { mapGetters, mapActions } from 'vuex';
import { getJwt } from '../../../../tools/http';

export default {
    name: 'TabAchievements',
    components: {
        EmptyTabsCard,
        ReportingItem,
    },
    data: () => ({
        loading: false,
    }),
    computed: {
        ...mapGetters(getters),
        rsvDomain() {
            return window.rsvDomain || 'rsv.ru';
        },
        userJwt() {
            return getJwt();
        },
        emptyImgLink() {
            return require(`../../../../assets/images/oops-rhino.svg`);
        },
    },
    watch: {},
    async created() {
        this.loading = true;
        await this.loadAchievements();
        this.loading = false;
    },
    methods: {
        ...mapActions(actions),
    },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/rem';
@import '~@/styles/mrem';

.box {
    background-color: #ffffff;
    border-radius: rem(10);
    padding: rem(32);
    display: block;

    @include on-mobile {
        padding: mrem(24) mrem(16);
        margin-top: mrem(16);
        background-color: white;
        box-shadow: 0 mrem(2) mrem(8) rgba(155, 161, 166, 0.23626);
        border-radius: mrem(10);
    }
}

.report {
    @include on-mobile {
        margin-bottom: mrem(24);
    }

    &-header {
        display: flex;

        &-left {
            flex: 1 1 auto;
            align-self: center;

            @include on-mobile {
            }

            h3 {
                font-weight: 600;
                font-size: rem(18);
                line-height: rem(28);
                display: block;

                @include on-mobile {
                    font-size: mrem(18);
                    line-height: mrem(21);
                }
            }
        }

        &-right {
            flex: 0 0 auto;
            font-size: rem(16);
            align-self: center;

            @include on-mobile {
                font-size: mrem(16);
            }

            a {
                color: #98a0a9;
            }
        }
    }

    .noreport {
        color: #98a0a9;
        font-size: rem(15);
        margin: 0;
        padding: 0;
    }
}
</style>
